var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61283 3.38718C1.27437 3.04872 0.725629 3.04872 0.387174 3.38718C0.0487197 3.72563 0.0487197 4.27437 0.387174 4.61283L1.61283 3.38718ZM3.66667 6.66667L3.05384 7.2795C3.3923 7.61795 3.94104 7.61795 4.27949 7.2795L3.66667 6.66667ZM9.61283 1.94616C9.95128 1.60771 9.95128 1.05896 9.61283 0.72051C9.27437 0.382056 8.72563 0.382056 8.38717 0.72051L9.61283 1.94616ZM6.33333 4L6.94616 4.61283L6.94616 4.61283L6.33333 4ZM0.387174 4.61283L3.05384 7.2795L4.27949 6.05384L1.61283 3.38718L0.387174 4.61283ZM4.27949 7.2795L6.94616 4.61283L5.72051 3.38718L3.05384 6.05384L4.27949 7.2795ZM6.94616 4.61283L9.61283 1.94616L8.38717 0.72051L5.72051 3.38718L6.94616 4.61283Z",
    fill: "#17161A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.092c7c9c25dbbbc5a4edf34e2f8dc221.svg";
export { ForwardRef as ReactComponent };